import React from "react";
import { cn } from "@/lib/utils";

interface ActionGroupProps {
  label: string;
  description: string;
  /** Visual tone of the role badge */
  tone?: "basp" | "basu" | "neutral";
  /** Renders labels in light colors for dark backgrounds */
  onDark?: boolean;
  columns?: 2 | 3;
  children: React.ReactNode;
  className?: string;
}

export const ActionGroup: React.FC<ActionGroupProps> = ({
  label,
  description,
  tone = "neutral",
  onDark = false,
  columns = 3,
  children,
  className,
}) => {
  return (
    <section className={cn("space-y-3", className)}>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <span
          className={cn(
            "inline-flex items-center rounded-md px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wider ring-1 ring-inset",
            onDark
              ? "badge-on-hero"
              : cn(
                  tone === "basp" && "bg-primary/10 text-primary ring-primary/25",
                  tone === "basu" && "bg-accent text-accent-foreground ring-border",
                  tone === "neutral" && "bg-muted text-muted-foreground ring-border"
                )
          )}
        >
          {label}
        </span>
        <span
          className={cn(
            "text-sm",
            onDark ? "on-hero-dim" : "text-muted-foreground"
          )}
        >
          {description}
        </span>
      </div>

      <div
        className={cn(
          "grid gap-4 items-stretch grid-cols-1 sm:grid-cols-2",
          columns === 3 && "lg:grid-cols-3"
        )}
      >
        {children}
      </div>
    </section>
  );
};
